var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"top"},[_c('Header'),_c('Search')],1),_c('div',{staticClass:"empty"}),_c('keep-alive',{attrs:{"include":['scoreRule', 'privateTerm', 'joinAgreement']}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }